<template>
  <div class="wrapper">
    <!-- Modal Component -->
    <b-modal 
      v-model="popUpModals"
      :no-close-on-backdrop="true" 
      hide-header
      hide-header-close
      :hide-footer="status!='error'"
      >

        <b-card-body>
          <b-spinner v-if="status=='loading'" variant="primary" label="Spinning"></b-spinner>
          <i v-if="status=='success'" style="color:#45A163" id="is-success" class="fa fa-check-circle-o"></i>
          <i v-if="status=='update'" style="color:#45A163" id="is-success" class="fa fa-check-circle-o"></i>
          <i v-if="status=='error'" style="color:#F75B38" id="is-error" class="fa fa-times-circle-o"></i>
          <h6>{{ title }}</h6>
          <br/>
          <h5>{{message}}</h5>
        </b-card-body>

        <!-- Footer -->
        <template v-slot:modal-footer>
          <b-row style="margin-top: 1em;" >
          <!-- Change To Success Icon Button -->
            <b-col sm xs="6"> 
              <b-button 
                variant="secondary" outline
                size="sm" 
                @click="closeModal"
              >
               Close
              </b-button>       
            </b-col>

          </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'modals',
  data () {
    return {
      popUpModals: false,
      isLoading: false,
      isSuccess: false,
      isError: false,
      status: 'loading',
      title: 'Loading...',
      message: '',
    }
  },
  methods: {
    closeModal(){
      this.popUpModals = false;
    },
    openModal() {
      this.popUpModals = true;
      this.isLoading = true;
    },
  }
}
</script>

<style scoped>
  div.col{
    padding: 5px !important;
  }
  .modal-footer{
    padding: 1.5rem !important;
  }
  div.card-body{
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
    text-align: center;
  }
  #is-success, #is-error {
    font-size: 40px;
    text-align: center;
    animation: fadein 2s;
    -moz-animation: fadein 2s; /* Firefox */
    -webkit-animation: fadein 2s; /* Safari and Chrome */
    -o-animation: fadein 2s; /* Opera */
  }
  @keyframes fadein {
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
  }
@-moz-keyframes fadein { /* Firefox */
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
}
@-webkit-keyframes fadein { /* Safari and Chrome */
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
}
@-o-keyframes fadein { /* Opera */
    from {
        opacity:0;
    }
    to {
        opacity: 1;
    }
}

</style>
